import __variableDynamicImportRuntimeHelper from "../../_virtual/dynamic-import-helper.js";
import { CURRENT_VERSION } from "./themes.js";
import { getRoot } from "./utils.js";
const INJECTION_ID = "__INJECTION_POINT__";
const importStylesheet = async (theme, retries = 3) => {
  try {
    return (await __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "../../styles/themes/v1/stylesheet.css": () => import("../../styles/themes/v1/stylesheet.css.js") }), `../../styles/themes/${CURRENT_VERSION}/stylesheet.css`, 6)).default;
  } catch (e) {
    if (retries > 0) {
      return importStylesheet(theme, retries - 1);
    }
    throw new Error(`[DSF] Could not load theme: ${theme} - ${e}`);
  }
};
const loadStyles = async (root) => {
  const rootElement = getRoot(root);
  if (!rootElement) {
    throw new Error(`[DSF] Could not find stylesheet version root: ${root}`);
  }
  const stylesheetId = `dsf-stylesheet-${CURRENT_VERSION}`;
  const fontId = `dsf-fonts-${CURRENT_VERSION}`;
  const stylesheetExists = document.querySelector(`style[data-${stylesheetId}]`);
  const fontExists = document.querySelector(`link[data-${fontId}]`);
  if (!stylesheetExists) {
    const style = await importStylesheet(CURRENT_VERSION);
    const versionedStyle = style.replaceAll(INJECTION_ID, `.${stylesheetId}`);
    const stylesheet = document.createElement("style");
    stylesheet.innerHTML = versionedStyle;
    stylesheet.setAttribute(`data-${stylesheetId}`, "");
    document.head.prepend(stylesheet);
  }
  if (!fontExists) {
    const font = document.createElement("link");
    font.rel = "stylesheet";
    font.setAttribute(`data-${fontId}`, "");
    font.href = "https://fonts.googleapis.com/css2?family=Inter:wght@100;300;400;500;700&family=Roboto:wght@100&display=swap";
    document.head.prepend(font);
  }
  rootElement.classList.add(stylesheetId);
};
export {
  INJECTION_ID,
  loadStyles
};
